import styled from "@emotion/styled";

const StyledSvg = styled.svg`
  width: 80px;
  height: 80px;
`;

const SmallStar = styled.path`
  animation: spin-small 3s linear infinite;
  transform-origin: center;
  transform-box: fill-box;

  @keyframes spin-small {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const MediumStar = styled.path`
  animation: spin-medium 4s linear infinite;
  transform-origin: center;
  transform-box: fill-box;

  @keyframes spin-medium {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(-360deg);
    }
  }
`;

const LargeStar = styled.path`
  animation: pulse-large 2s ease-in-out infinite;
  transform-origin: center;
  transform-box: fill-box;

  @keyframes pulse-large {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.15);
    }
    100% {
      transform: scale(1);
    }
  }
`;

export function LoadingStars() {
  return (
    <StyledSvg
      viewBox="-5 -5 79 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <SmallStar
        d="M30.5664 0.261185C30.6953 -0.0870619 31.1878 -0.0870618 31.3167 0.261186L32.4787 3.40161C33.0459 4.93444 34.2545 6.14298 35.7873 6.71018L38.9277 7.87224C39.276 8.00111 39.276 8.49366 38.9277 8.62252L35.7873 9.78459C34.2545 10.3518 33.0459 11.5603 32.4787 13.0932L31.3167 16.2336C31.1878 16.5818 30.6953 16.5818 30.5664 16.2336L29.4044 13.0932C28.8372 11.5603 27.6286 10.3518 26.0958 9.78459L22.9554 8.62252C22.6071 8.49366 22.6071 8.00111 22.9554 7.87224L26.0958 6.71018C27.6286 6.14298 28.8372 4.93444 29.4044 3.40161L30.5664 0.261185Z"
        fill="url(#paint0_linear_37466_34953)"
      />
      <MediumStar
        d="M11.4622 14.5142C11.6412 14.0306 12.3253 14.0306 12.5043 14.5142L14.1183 18.8759C14.906 21.0049 16.5846 22.6834 18.7135 23.4712L23.0752 25.0851C23.5589 25.2641 23.5589 25.9482 23.0752 26.1272L18.7135 27.7412C16.5846 28.529 14.906 30.2075 14.1183 32.3364L12.5043 36.6981C12.3253 37.1818 11.6412 37.1818 11.4622 36.6981L9.84826 32.3364C9.06048 30.2075 7.38196 28.529 5.25303 27.7412L0.891321 26.1272C0.407645 25.9482 0.407646 25.2641 0.891323 25.0851L5.25303 23.4712C7.38196 22.6834 9.06048 21.0049 9.84826 18.8759L11.4622 14.5142Z"
        fill="url(#paint1_linear_37466_34953)"
      />
      <LargeStar
        d="M42.1831 19.9838C42.576 18.9221 44.0777 18.9221 44.4706 19.9838L48.0135 29.5583C49.7427 34.2315 53.4273 37.9161 58.1005 39.6453L67.6751 43.1882C68.7368 43.5811 68.7368 45.0828 67.6751 45.4757L58.1005 49.0185C53.4273 50.7478 49.7427 54.4323 48.0135 59.1056L44.4706 68.6801C44.0777 69.7418 42.576 69.7418 42.1831 68.6801L38.6403 59.1056C36.911 54.4323 33.2264 50.7478 28.5532 49.0185L18.9787 45.4757C17.917 45.0828 17.917 43.5811 18.9787 43.1882L28.5532 39.6453C33.2264 37.9161 36.911 34.2315 38.6403 29.5583L42.1831 19.9838Z"
        fill="url(#paint2_linear_37466_34953)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_37466_34953"
          x1="34.5"
          y1="0"
          x2="34.5"
          y2="69.4764"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2E5FB" />
          <stop offset="1" stopColor="#9F88F5" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_37466_34953"
          x1="34.5"
          y1="0"
          x2="34.5"
          y2="69.4764"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2E5FB" />
          <stop offset="1" stopColor="#9F88F5" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_37466_34953"
          x1="34.5"
          y1="0"
          x2="34.5"
          y2="69.4764"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2E5FB" />
          <stop offset="1" stopColor="#9F88F5" />
        </linearGradient>
      </defs>
    </StyledSvg>
  );
}
